import {
  SITE_ORIGIN,
  SITE_NAME,
  SITE_DESCRIPTION,
  FAVICON_URL,
} from "./site";
import type { PillarArticle } from "@/mocks/articles";

type LangCode = "en" | "fr" | "da" | "de";

export function buildWebSiteSchema(): object {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: SITE_NAME,
        url: `${SITE_ORIGIN}/`,
        description: SITE_DESCRIPTION,
        inLanguage: ["en", "fr", "da", "de"],
      },
      {
        "@type": "Organization",
        name: SITE_NAME,
        url: `${SITE_ORIGIN}/`,
        logo: FAVICON_URL,
      },
    ],
  };
}

export function buildArticleSchema(
  article: PillarArticle,
  lang: LangCode,
  slug: string
): object {
  const url = `${SITE_ORIGIN}/article/${slug}`;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title[lang],
    description: article.meta[lang],
    image: article.image,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    url,
    inLanguage: lang,
    datePublished: "2026-08-25",
    dateModified: "2026-08-25",
    author: {
      "@type": "Organization",
      name: SITE_NAME,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: FAVICON_URL,
    },
  };
}

export function injectJsonLd(data: object) {
  const id = "seo-jsonld";
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd() {
  const el = document.getElementById("seo-jsonld");
  if (el) el.remove();
}